/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Following_Level_StatusInputs */

const en_following_level_status = /** @type {(inputs: Following_Level_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status changes`)
};

/**
* | output |
* | --- |
* | "Status changes" |
*
* @param {Following_Level_StatusInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const following_level_status = /** @type {((inputs?: Following_Level_StatusInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Following_Level_StatusInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_following_level_status(inputs)
});